import { useConsultDoctorContext } from "../../Contexts/ConsultDoctorContext";
import SearchSpecialization from "../../Components/SearchSpecialization";
import { CircularProgress, Divider, Grid } from "@mui/material";
import ErrorComponent from "../../Components/ErrorComponent";
import * as ScrollArea from "@radix-ui/react-scroll-area";
import { baseUrl } from "../../utilities/configurations";
import { ScrollBar } from "../../Components/ScrollBar";
import apiRequest from "../../utilities/request";
import clockIcon from "../../assets/clock.png";
import dayjs from "dayjs";

function TimesContent() {

    const {
        setSelectedDoctorBySearchAvailableTime,
        selectedDoctorBySearchAvailableTime,
        selectedDoctorBySearch,
        convertToStandardTime,
        toSearchByDoctor,
        setSelectedTime,
        selectedTime,
        setLoadState,
        selectedDate,
        loadState
    } = useConsultDoctorContext();

    const getSelectedDoctorBySearchAvailableTime = async (state) => {
        try {
        setLoadState(state || "get times");
        const res = await apiRequest(
            baseUrl +
            `/consult/times?date=${dayjs(selectedDate).format(
                "YYYY-MM-DD"
            )}&specializationId=${
                selectedDoctorBySearch?.specializationId
            }&physicianId=${selectedDoctorBySearch?.id}`,
            "GET"
        );
        if (!res.error) {
            let slots = res.data || [];
            setSelectedDoctorBySearchAvailableTime(
                slots.map((slot) => dayjs(slot.time).format("HH:mm"))
            );
            setLoadState("get times success");
        } else if (res.status >= 500) {
            setLoadState("get times ISE");
        } else {
            setLoadState("get times failed");
        }
        } catch (error) {
            setLoadState("get times timeout");
        }
    };

    const checkTimes = (time) => {
        let times = selectedDoctorBySearchAvailableTime;
        if (time === "Morning") {
            times = times.filter(
                (t) => dayjs(t, "HH:mm").hour() >= 7 && dayjs(t, "HH:mm").hour() < 12
            );
        } else if (time === "Afternoon") {
            times = times.filter(
                (t) => dayjs(t, "HH:mm").hour() >= 12 && dayjs(t, "HH:mm").hour() < 17
            );
        } else if (time === "Evening") {
            times = times.filter(
                (t) => dayjs(t, "HH:mm").hour() >= 17 && dayjs(t, "HH:mm").hour() < 20
            );
        }
        return times || [];
    };

    const populateAvailableTime = (time) => {
        let times = checkTimes(time);
        return times.map((item) => (
            <Grid item xs={6} key={item}>
                <label id="labl">
                    <input
                        type="radio"
                        id="time"
                        name="time"
                        onChange={() => setSelectedTime(item)}
                        checked={selectedTime === item}
                    />
                    <div className="border rounded-lg p-3 cursor-pointer">
                        <div className="text-sm text-center">
                        {convertToStandardTime(item)}
                        </div>
                    </div>
                </label>
            </Grid>
        ));
    };

    let timesBySearch = null;

    if (loadState === "get times") {
        timesBySearch = (
            <div className="w-full flex justify-center items-center mt-4">
                <CircularProgress />
            </div>
        );
    } else if (
        ["get times ISE", "get times retry", "get times timeout"].includes(
        loadState
        )
    ) {
        timesBySearch = (
            <ErrorComponent
                onRetry={() =>
                    getSelectedDoctorBySearchAvailableTime("get times retry")
                }
                isLoading={loadState === "get times retry"}
            />
        );
    } else if (selectedDoctorBySearchAvailableTime) {
        timesBySearch = (
            <ScrollArea.Root className="w-full rounded overflow-hidden bg-white">
                <ScrollArea.Viewport className="w-full sm:h-52 h-[60vh] rounded">
                <Divider
                    textAlign="left"
                    sx={{
                    "& .MuiDivider-wrapper": {
                        padding: 0,
                        paddingRight: 2,
                    },
                    "&::before": { width: 0 },
                    }}
                >
                    Morning
                </Divider>
                <Grid container spacing={2}>
                    {populateAvailableTime("Morning")}
                    {checkTimes("Morning").length === 0 && (
                    <div className="w-full flex flex-col justify-center items-center mt-4">
                        <img src={clockIcon} alt="no-timeslot" className="w-24 h-24" />
                        <p>No timeslots available</p>
                    </div>
                    )}
                </Grid>
                <Divider
                    textAlign="left"
                    sx={{
                    "& .MuiDivider-wrapper": {
                        padding: 0,
                        paddingRight: 2,
                    },
                    "&::before": { width: 0 },
                    }}
                >
                    Afternoon
                </Divider>
                <Grid container spacing={2}>
                    {populateAvailableTime("Afternoon")}
                    {checkTimes("Afternoon").length === 0 && (
                    <div className="w-full flex flex-col justify-center items-center mt-4">
                        <img src={clockIcon} alt="no-timeslot" className="w-24 h-24" />
                        <p>No timeslots available</p>
                    </div>
                    )}
                </Grid>
                <Divider
                    textAlign="left"
                    sx={{
                    "& .MuiDivider-wrapper": {
                        padding: 0,
                        paddingRight: 2,
                    },
                    "&::before": { width: 0 },
                    }}
                >
                    Evening
                </Divider>
                <Grid container spacing={2}>
                    {populateAvailableTime("Evening")}
                    {checkTimes("Evening").length === 0 && (
                    <div className="w-full flex flex-col justify-center items-center mt-4">
                        <img src={clockIcon} alt="no-timeslot" className="w-24 h-24" />
                        <p>No timeslots available</p>
                    </div>
                    )}
                </Grid>
                </ScrollArea.Viewport>
                <ScrollBar />
            </ScrollArea.Root>
        );
    }

    let content = null;

    if (toSearchByDoctor) {
        content = timesBySearch;
    } else {
        content = <SearchSpecialization />;
    }

    return content;
}

export default TimesContent